import { z } from 'zod';

// All valid user roles in the system
export const USER_ROLES = [
  'super_admin',
  'admin', 
  'owner', 
  'project_manager', 
  'design_manager', 
  'production_manager', 
  'inventory_manager', 
  'procurement_officer',
  'sales_team', 
  'hr_manager',
  'worker'
] as const;

export type UserRole = typeof USER_ROLES[number];

// Schema for creating new users
export const createUserSchema = z.object({
  email: z.string().email('Invalid email address'),
  firstName: z.string().min(2, 'Full name must be at least 2 characters'),
  mobileNumber: z.string()
    .min(10, 'Mobile number must be at least 10 digits')
    .regex(/^[0-9+\-\s()]*$/, 'Invalid mobile number format')
    .optional(),
  role: z.enum(USER_ROLES, {
    required_error: 'Please select a role'
  })
});

// Schema for editing existing users
export const editUserSchema = z.object({
  full_name: z.string().min(2, 'Full name must be at least 2 characters'),
  role: z.enum(USER_ROLES, {
    required_error: 'Please select a role'
  }),
  mobile_number: z.string()
    .min(10, 'Mobile number must be at least 10 digits')
    .regex(/^[0-9+\-\s()]*$/, 'Invalid mobile number format')
    .optional()
    .nullable(),
  status: z.enum(['active', 'inactive', 'suspended'], {
    required_error: 'Please select a status'
  })
});

export type CreateUserFormData = z.infer<typeof createUserSchema>;
export type EditUserFormData = z.infer<typeof editUserSchema>;
